import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://joiubccqnnjvuxoqfzal.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpvaXViY2Nxbm5qdnV4b3FmemFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3MjUxNTIsImV4cCI6MjA2NTMwMTE1Mn0.OrjK_VmvY-A6NqgZuc36ekmmPax2ibmsAB46mwVOlB0'

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})